// @ts-nocheck
import { toast } from 'react-toastify';
import { getUserEmail, deleteCookie } from '../config/common';
import * as services from '../Services/services';

/**
 * SECURITY: Cookies are not the only place we cache identity. The login flow
 * also writes `copilotUserEmail` (sessionStorage) and `reqData` (localStorage),
 * and `DashboardUserProfile` reads `copilotUserEmail` to render the top bar.
 * If we clear cookies but leave storage intact, a logged-out user navigating
 * to a protected route would still see the previous user's email in the chrome.
 * Clear everything together.
 */
function clearClientSession(): void {
  deleteCookie('sessionId');
  deleteCookie('copilot');
  deleteCookie('accesscode');
  try { sessionStorage.removeItem('copilotUserEmail'); } catch (_) { /* ignore */ }
  try { sessionStorage.removeItem('copilot_returnUrl'); } catch (_) { /* ignore */ }
  try { localStorage.removeItem('reqData'); } catch (_) { /* ignore */ }
}

/**
 * Shared logout used by Copilot and dashboard chrome.
 */
export async function logoutUser(): Promise<void> {
  try {
    const email = getUserEmail();
    const data = { data: JSON.stringify({ email }) };
    const response = await services.logout(data);

    if (response && response.data && response.data.status === 1) {
      clearClientSession();
      toast.success('Logged out successfully');
      window.location.href = '/';
      return;
    }
    toast.error('Logout failed. Please try again.');
  } catch (error) {
    console.error('Logout error:', error);
    clearClientSession();
    toast.error('Session cleared locally');
    window.location.href = '/';
  }
}
